import React, {useMemo, useState} from 'react';

import {Button, Input, ModalPopup} from '@kit';

import {useCharacter} from '../../../character-context';
import {byTitle} from '../../format';
import {useFeatureAction} from '../use-feature-action';
import type {ProcedureModalProps} from './procedure-modal-props';

import css from '../../sheet.module.css';

/** Божественное вмешательство: любое заклинание списка класса до указанного круга без траты ячейки */
export const SpellChoiceModal: React.FC<ProcedureModalProps<'spellChoice'>> = ({action, procedure, onClose}) => {
	const {catalog} = useCharacter();
	const {spend, canUse} = useFeatureAction(action);
	const [query, setQuery] = useState('');

	const spells = useMemo(
		() =>
			catalog.spells
				.filter(
					(spell) =>
						spell.classIds.includes(procedure.spellList) &&
						spell.level > 0 &&
						spell.level <= procedure.maxLevel,
				)
				.sort((first, second) => first.level - second.level || byTitle(first.title, second.title)),
		[catalog, procedure],
	);
	const normalizedQuery = query.trim().toLowerCase();
	const visible = normalizedQuery
		? spells.filter((spell) => spell.title.toLowerCase().includes(normalizedQuery))
		: spells;

	const cast = (title: string, level: number) => {
		spend(`${title}, ${level} круг`);
		onClose();
	};

	return (
		<ModalPopup open onClose={onClose} header={action.title} maxWidth={560}>
			{!canUse && <p className={css.muted}>Использований не осталось.</p>}
			<Input
				autoFocus
				value={query}
				placeholder="Найти заклинание"
				onChange={(value) => setQuery(String(value ?? ''))}
			/>
			<ul className={css.rows}>
				{visible.map((spell) => (
					<li key={spell.id} className={css.row}>
						<div className={css.rowMain}>
							<span className={css.rowTitle}>
								{spell.title} <span className={css.muted}>· {spell.level} круг</span>
							</span>
							<Button size="small" disabled={!canUse} onClick={() => cast(spell.title, spell.level)}>
								Сотворить
							</Button>
						</div>
					</li>
				))}
			</ul>
		</ModalPopup>
	);
};
